import { PropaneTankSharp } from "@mui/icons-material";
import { useEffect, useState } from "react";
// import AxiosInstance from "../Axios";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import AxiosInstance from "src/components/Axios";
import axios from 'axios';

const urlApi = '/languages';
const urlApi_1 = '/products_releteds';
const urlApi_2 = '/media_objects';
const tokenStr = localStorage.getItem('user');


const LangugesPanel = ({ data, setLaguage, language, setMyData }) => {
   const navigate = useNavigate();

   console.log('data', data);
   console.log('laguage', language)
   const [languagesList, setLaguagesList] = useState([]);
   // const [language, setLaguage] = useState('');
   // const [language, setLaguage] = useState((data != undefined)? data.language.key: 'ua');
   //змінна для схожих продуктів батька
   const [productsReleted, setProductsReleted] = useState([])
   const [translations, setTranslations] = useState((data != undefined && data.translations != undefined) ? data.translations : false);
   //флаг для search
   let search = true
   const getLangs = () => {
      AxiosInstance.get(`${urlApi}?page=1`).then((response) => {
         setLaguagesList(response.data['hydra:member'])
      })
   }
   //зак
   useEffect(() => {
      setLaguage((data != undefined && data.language != undefined) ? data.language.key : 'ua');
      if (data?.translations) {
         setTranslations(prev => data.translations)
         setMyData(data)
      } else {
         setTranslations(false)
      }
      getLangs();

   }, [data]);

   //Функція для запиту за продуктами
   const getProductsReleted = (id) => {
      // setIsLoading(true)
      return AxiosInstance.get(`${urlApi_1}`,
         {
            params: {
               "product.id": id,
            }
         }
      ).then((response) => {
         let productsData = response.data["hydra:member"];
         setProductsReleted(productsData)
         return productsData
      }).catch((error) => {
         console.log("Помилка запиту за продуктами: ", error);
      }).finally(() => {
         //  setIsLoading(false)
      }
      )
   };

   //Функція для файлу по айді mediaObjects

   function getMediaFile() {
      const contentUrl = "media/2025/03/67dd9d662fb76_cute-cat-studio.jpg"
      const filePath = '67dd9d662fb76_cute-cat-studio.jpg'
      return axios.get(`${process.env.REACT_APP_SERVER_URL}/${contentUrl}`,
         {
            // responseType: 'blob',
            responseType: 'json'
            // headers: {
            //    'Accept': 'application/json',
            //    "Authorization": `Bearer ${tokenStr}`
            // }
         }
      ).then((response) => {
         let mediaData = response.data["hydra:member"];
         console.log('responseMedia', response)
         // setProductsReleted(productsData)
         return mediaData
      }).catch((error) => {
         console.log("Помилка запиту за файлом медіа: ", error);
      }).finally(() => {
         //  setIsLoading(false)
      }
      )
   }

   // useEffect(() => {
   //    getMediaFile()
   // }, [])


   const CreateTranslate = (e, l) => {
      console.log('l', l)

      const data_response = {
         name: data.name,
         // slug: `${data.slug}_${l.key}`,
         content: data.content,
         category: data.category.map(elem => elem["@id"]) || [],
         media: data.media.map(elem =>
            // elem["@id"]
            `/api/media_objects/${elem.id}`
         ) || [],
         attributeItems: data.attributeItems.map(elem => elem["@id"]) || [],
         price: data.price,
         oldPrice: data.oldPrice,
         isSalle: data.isSalle
         //лишнє поле synonym
         // synonym: `${data.synonym}_${l.key}`,
         // status: data.status,
         //лишнє поле type
         // type: data.type,
         // slider: data.slider,
         // pageInfos: (data.pageInfos && data.pageInfos.length > 0) ? data.pageInfos.map(elem => `/api/page_infos/${elem.id}`) : [],
         // galleries: data.galleries
      };
      data_response['language'] = `/api/languages/${l.id}`;
      data_response['translation'] = `/api/products/${data.id}`;
      const response = AxiosInstance.post(`/products`, data_response).then((response) => {
         if (response.status === 201) {

            console.log(response, "response")
            getProductsReleted(response.data.translation.id).then((res) => {
               // тут запит на створення reletedProducts
               console.log(res, "res")
               const newProductId = response.data.id;

               // Масив промисів для створення схожих товарів
               const postRequests = res.filter(
                  elem => elem.relatedProduct.translations?.length > 0
                     && elem.relatedProduct.translations.some(
                        translation => {
                           // console.log(translation?.language?.key, 'translation?.language?.key')
                           // console.log(language, 'language')
                           if (translation?.language?.key === l.key

                           ) {
                              return true
                           }
                           else {
                              return false
                           }
                        }
                     )).map((product) => {

                        //тут умова 
                        const foundTranslation = product.relatedProduct.translations.find(
                           translation => translation?.language?.key === l.key
                           // response.data.language.key
                        );
                        console.log('foundTranslation', foundTranslation)
                        if (!foundTranslation) {
                           console.warn('Не знайдено переклад для товару:', product);
                           return null;
                        }


                        return AxiosInstance.post(`${urlApi_1}`, {
                           product: `/api/products/${newProductId}`,
                           //(знизу)замість translations[0].id тут потрібно буде через find знахохити lang в translations і порівнювати його з мовою створеного перекладу  і додадвати
                           // relatedProduct: `/api/products/${product.relatedProduct.translations[0].id}`,
                           relatedProduct: `/api/products/${foundTranslation.id}`
                           // ///
                        });

                     });

               Promise.all(postRequests)
                  .then((results) => {
                     console.log("Всі related-products успішно створені", results);
                     // navigate(`/products/update/${newProductId}`);
                     console.log('results', results)
                  })
                  .catch((error) => {
                     console.error("Помилка при створенні related-products:", error);
                  });

               // тут запит на створення reletedProducts


            })

            //запит get за медіа обжектами батька і створеня нових mediaObjects



            return navigate(`/products/update/${response.data.id}`);
         }
      }).catch((error) => {
         console.error("Error creating translation:", error);
      });

   }

   // console.log('data', data)
   // console.log('languageList', languagesList)
   // console.log(data.pageInfos.map(elem => `/api/page_infos/${elem.id}`))
   return (
      <div>
         {/* <div>: </div> */}
         <div>
            <ul>
               {
                  (data != undefined && data.translation != undefined && data.translation && data.translation.id != undefined) ?
                     <>
                        <h4>Переклад: {language}</h4>
                        <Link to={`/products/update/${data.translation.id}`}>Повернутися до UA</Link>
                     </>
                     :
                     <>
                        <h4>Переклад: {language}</h4>
                        {/* <li className='btn btn-secondary text-white'>{language}</li> */}
                        {languagesList.map((l) => {
                           // let search = true;
                           search = true
                           // console.log('translations', translations);
                           if (l.key != language) {
                              // if (translations !== false) {
                              if (translations?.length > 0) {
                                 // console.log("!!!!")
                                 let t = translations.filter(t => t.language?.key === l.key)
                                 if (t.length > 0) {
                                    // console.log('search', search)
                                    return (<Button key={l.id} variant="outline-secondary ml-5" ><Link to={`/products/update/${t[0].id}`} >{l.key}</Link></Button>);
                                 }
                                 else
                                    search = false;

                              } else {
                                 search = false;

                              }
                           }
                           if (!search) {
                              // console.log('search', search)
                              return (<Button key={l.id}
                                 variant="outline-secondary mr-5"
                                 onClick={(e) => { CreateTranslate(e, l) }}
                              >
                                 додати  <b>{l.key}</b>
                              </Button>);
                           }

                        })}
                     </>
               }
            </ul>
         </div>

      </div>


   );

}

export default LangugesPanel;